<template>
  <div class="device_details_cla">
    <div class="search-bar-margin-bottom-cla">
      <div class="goBack" @click="goBack">
        <i class="goback-icon-cla"></i>
        <span>{{ $t('developer.goback') }}</span>
      </div>
    </div>

    <div class="black_panel_cla tab_panel_cla">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane  v-if="hasPermission('c242f4c3c2544d029b3f9e63d6886634')"  :label="this.$t('device.deviceDetails')" name="1">
        </el-tab-pane>
        <el-tab-pane v-if="hasPermission('f67937bf376b4b11a34b21220dabede4')" :label="this.$t('device.deviceEmploye')" name="4">
        </el-tab-pane>
        <el-tab-pane
          :label="$t('device.deviceSetting')"
          name="7"
          v-if="hasPermission('e706ccf0745742df8b727d1cbe72fa08')"
        >
        </el-tab-pane>
        <el-tab-pane
          v-if="hasPermission('2169b2a7c07c4391bdd7bb168467eed2')"
          :label="this.$t('device.deviceHistoryLog')"
          name="2"
        >
        </el-tab-pane>

        <el-tab-pane
          v-if="hasPermission('b5a7c70e7485456385dce67945a0ec59')"
          :label="this.$t('device.com_log')"
          name="5"
        >
        </el-tab-pane>

        <el-tab-pane
          v-if="hasPermission('340bdf4da357496ea8bb864a8493d98b')"
          :label="this.$t('device.deviceOptions')"
          name="3"
        >
        </el-tab-pane>

        <el-tab-pane
          v-if="hasPermission('d05b9f31a8f948a69a4930820e03009c')"
          :label="this.$t('device.deviceCommand')"
          name="6"
        >
        </el-tab-pane>

        <el-tab-pane
          v-if="hasPermission('ad8ff38836b843e99a80c07ddbf72887')"
          :label="this.$t('device.updateHistory')"
          name="8"
        >
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="tab-panelInfo-cla">
      <deviceDetail
        v-if="activeName === '1'"
        @deviceInfo="deviceInfo"
        ref="deviceDetail"
        :deviceSn="devSn"
      ></deviceDetail>
      <deviceHistoryLog
        style="padding: 10px;"
        :contentHeight="contentHeight - 30"
        v-if="activeName === '2'"
        :devSn="devSn"
      ></deviceHistoryLog>

      <deviceSetting
        v-if="activeName === '7'"
        style="padding: 10px;"
        :devSn="devSn"
        :contentHeight="contentHeight"
      ></deviceSetting>

      <deviceOptions
        style="padding: 10px;"
        :contentHeight="contentHeight"
        v-if="activeName === '3'"
        :devSn="devSn"
      ></deviceOptions>

      <deviceEmploye
        style="padding: 10px;"
        :contentHeight="contentHeight"
        v-if="activeName === '4'"
        :devSn="devSn"
      ></deviceEmploye>

      <communicationLog
        style="padding: 10px;"
        :contentHeight="contentHeight"
        :devSn="devSn"
        :isDevicePage="true"
        v-if="activeName === '5'"
      ></communicationLog>

      <devicesCommand
        style="padding: 10px;"
        v-if="activeName === '6'"
        :devSn="devSn"
      ></devicesCommand>

      <updateHistory
        style="padding: 10px;"
        v-if="activeName === '8'"
        :devSn="devSn"
        :isDevicePage="true"
      ></updateHistory>
    </div>
  </div>
</template>

<script>
import deviceDetail from './deviceCmp/deviceDetail.vue'
import deviceHistoryLog from './deviceCmp/deviceHistoryLog.vue'
import deviceOptions from './deviceCmp/deviceOptions'
import communicationLog from './communicationLog'
import deviceEmploye from './deviceCmp/deviceEmploye'
import devicesCommand from './devicesCommand'
import deviceSetting from './deviceCmp/deviceSetting'
import updateHistory from './deviceCmp/updateHistory'
export default {
  data() {
    return {
      activeName: '1',
      devSn: '',
      isCmp: false,
      companyId: '',
      contentHeight: 500
    }
  },
  mounted() {
    this.devSn = this.$route.query.sn
    let temp = this.$route.query.isCmp
    this.isCmp = !!(temp === 'true' || temp === true)
    this.companyId = this.$route.query.companyId
  },
  components: {
    deviceDetail,
    deviceHistoryLog,
    deviceOptions,
    deviceEmploye,
    communicationLog,
    devicesCommand,
    deviceSetting,
    updateHistory
  },
  methods: {
    goBack() {
      if (this.isCmp) {
        this.$router.push({
          path: '/tenantManager/companyDetails',
          query: {
            companyId: this.companyId
          }
        })
      } else {
        this.$router.push({ path: '/deviceManager/deviceList' })
      }
    }
  }
}
</script>

<style scoped lang="less">
.tab_panel_cla {
  padding-left: 30px;
  padding-bottom: 0px;
  /deep/.el-tabs__nav-wrap {
    &:after {
      height: 0px;
    }
  }
}
.tab-panelInfo-cla {
  margin-top: 10px;
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/deviceManager/deviceDetails.vue